// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__mLkGN","container":"Modal_container__BmSJT","closeButtonWrapper":"Modal_closeButtonWrapper__4vJCe"};